export abstract class HtmlUtils {
    public static removeAllChildren(htmlElement: HTMLElement): void {
        while (htmlElement.lastChild) {
            htmlElement.removeChild(htmlElement.lastChild);
        }
    }
    public static getNotNullElementById(id: string): HTMLElement {
        const element = document.getElementById(id);
        if (element == null) {
            throw new Error(`Html element with id "${id}" not found`);
        }
        return element;
    }
}